import React from 'react';
import ReactDOM from 'react-dom';
import { Form, Modal, Button } from 'antd';
const FormItem = Form.Item;
import { PrmFactory } from 'rt-sd-common/sgiFactory/PrmFactory'
import { Resource } from 'rt-sd-common/sgiFactory/Resource';
import { SgiMainComp } from './SgiMainComp';
import { SgiEventHandler } from './SgiEventHandler';

class SgiModal extends React.Component {

    static defaultProps = {
    };  // 注意这里有分号
    static propTypes = {
    };  // 注意这里有分号

    constructor(props) {
        super(props);

        //初始化state属性
        // this.initState();
        //初始化state
        this.state = {
            popProps: { style: {} }, // 弹出窗自身属性
            popItems: [], // 弹出窗内容
            visible: this.props.visible, // 弹出窗对话框是否可见
            functions: {}
        };

        var { uid, objFct, curtitle, onCancel } = this.props;
        //组装属性 初始化属性到this.state
        this.modal_mk(uid, objFct, curtitle, onCancel);
    }

    /**
     * 根据描述创建文本框
     * @param {弹出页面guid} uid
     * @param {对象工厂} objFct
     * @param {弹出窗标题} curtitle
     */
    modal_mk(uid, objFct, curtitle, onCancel) {
        //获取需要展示的数据信息
        if (!uid) {
            return;
        }
        var uiJson = PrmFactory.getPrm(uid);
        if (!uiJson) {
            return;
        }
        //转换基础属性
        this.AddInputAttribute(uiJson, this.state.popProps, curtitle, onCancel);
        //绑定事件
        this.bindEvent(uiJson, this.state.popProps, this.state.functions);
        // 添加弹出内容
        this.state.popItems.push(<SgiMainComp objFct={objFct} moduleDesc={uiJson} />);
    }

    /**
     * 绑定事件
     * @param {*} moduleDesc
     * @param {*} treeProps
     */
    bindEvent(uiJson, popProps, functions) {
        var clsLsn = uiJson.clsLsn; // 用户自定义关闭事件
        if (clsLsn) {
            var $clsLsn = new Function("module", "objFct", "e", clsLsn);
            functions.afterClose = $clsLsn;
        }
        popProps.afterClose = SgiEventHandler.ctnCls.bind(this);
    }

    /**
     * 属性转换
     * @param {描述信息} moduleDesc
     * @param {属性} popProps
     */
    AddInputAttribute(moduleDesc, popProps, curtitle, onCancel) {
        if (curtitle) {
            popProps.title = curtitle;
        } else {
            if (moduleDesc.te || moduleDesc.teid) {//避免不必要的执行getTRByPrm()方法
                var title = Resource.getTRByPrm(moduleDesc).te; //标题
                if (title) popProps.title = title;
            }
        }
        popProps.closable = true; //显示右上角的关闭按钮
        popProps.maskClosable = false; //点击蒙层是否允许关闭
        popProps.onCancel = () => { //点击遮罩层或右上角叉或取消按钮的回调
            this.setState({
                visible: false,
            });
            onCancel();
        }

        const ctlW = moduleDesc.ctlW;
        const fixedW = (ctlW && (typeof ctlW === "number" || (typeof ctlW === "string" && ctlW.indexOf("%") === -1))) ? ctlW : "80%";
        popProps.width = this.props.width || fixedW;
        // var width = this.props.width;//moduleDesc.ctlW; // 宽度，string|number	520
        // if (width) {
        //     popProps.width = width;
        // } else {
        //     popProps.width = "80%";
        // }

        const ctlH = moduleDesc.ctlH;
        const fixedH = (ctlH && (typeof ctlH === "number" || (typeof ctlH === "string" && ctlH.indexOf("%") === -1))) ? ctlH : "80%";
        var height = this.props.height;//moduleDesc.ctlH;
        if (height) {
            popProps.height = height;
            this.state.wrapClassName = "sgiModal";
        } else {
            popProps.height = fixedH;
            this.state.wrapClassName = undefined;
        }

        // if (!popProps.style) popProps.style = {};
        // popProps.style.overflow = "hidden"; // 强制子组件不得超出父组件

        // 底部内容，当不需要默认底部按钮时，可以设为 footer={null}
        popProps.footer = null;//不需要确认取消按钮
        // var footer = moduleDesc.footer;
        // if (footer == null) {
        //   inputprops.footer = footer;
        // }else if (footer.length != 0) {
        //   inputprops.footer = footer;
        // }
    }
    /**
     * 关闭，直接调用afterClose就可以关闭
     * @return {[type]} [description]
     */
    onCancel() {
        this.state.popProps.afterClose();
    }

    //渲染并返回一个虚拟DOM
    render = function () {
        return (
            <Modal centered {...this.state.popProps} visible={this.state.visible} wrapClassName={this.state.wrapClassName}>
                {this.state.popItems}
            </Modal>
        );
    }
}

export { SgiModal };
export default SgiModal;



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiModal.js